<div class="flex align-items-center cursor" 
    [pTooltip]="isTooltip ? userName : null"
    tooltipPosition="bottom"
    (mouseenter)="!isTooltip && compact && onMouseEnter()"
    (mouseleave)="!isTooltip && compact && onMouseLeave()">
    <p-chip [label]="showLabel ? userName : (displayImage ? '' : (userName | userInitials))" [image]="displayImage" 
    [styleClass]="setStyleClass()"></p-chip>
</div>